import { Experiment } from 'api/experiment/types'

export const experiments: Experiment[] = [
  {
    id: '1',
    placement: {
      id: '1',
    },
    name: 'Experiment #1',
    placementVariants: [
      {
        id: '1',
        name: 'Baseline',
        percentage: 80,
        tabsEnabled: false,
        turboEnabled: false,
        webOfwEnabled: false,
        colors: {
          tagColor: '#e21212',
          buttonColor: '#e21212',
          buttonTextColor: '#e21212',
        },
        mobileBannerUrl:
          'https://ofw-assets-stg.s3.eu-west-1.amazonaws.com/opd/placement_mobile_banner/308599f4-476a-4038-bf50-66398d16fa4b.jpeg',
        tabletBannerUrl: '',
        virtualCurrency: {
          id: '1',
        },
        exchangeRates: [
          {
            id: '1',
            rate: 1.5,
            countries: ['WW'],
          },
          {
            id: '2',
            rate: 3,
            countries: ['TR', 'FR', 'AL'],
          },
        ],
      },
      {
        id: '2',
        name: 'Variant #2',
        percentage: 20,
        tabsEnabled: false,
        turboEnabled: false,
        webOfwEnabled: false,
        colors: {
          tagColor: '#e21212',
          buttonColor: '#e21212',
          buttonTextColor: '#ffffff',
        },
        mobileBannerUrl:
          'https://ofw-assets-stg.s3.eu-west-1.amazonaws.com/opd/placement_mobile_banner/308599f4-476a-4038-bf50-66398d16fa4b.jpeg',
        tabletBannerUrl: '',
        virtualCurrency: {
          id: '1',
        },
        exchangeRates: [
          {
            rate: 2,
            countries: ['WW'],
          },
          {
            rate: 3,
            countries: ['TR', 'FR', 'AL', 'RO'],
          },
        ],
      },
    ],
  },
]
